import { render, staticRenderFns } from "./Overtime.vue?vue&type=template&id=23c1a9ef&scoped=true"
import script from "./Overtime.vue?vue&type=script&lang=js"
export * from "./Overtime.vue?vue&type=script&lang=js"
import style0 from "./Overtime.vue?vue&type=style&index=0&id=23c1a9ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c1a9ef",
  null
  
)

export default component.exports